import { Controller as BaseController } from 'stimulus'

/**
 * @namespace Searchv2 LoadMoreButton
 */
export class Controller extends BaseController {
  onLoadMore() {
    this.element.setAttribute('loading', 'true')
    this.element.blur()
  }
}
